import { FaqLayout as MobileFaq } from '@/components/mo/Faq';
import { FaqLayout as PcFaq } from '@/components/pc/Faq';
import { useIsMobile } from '@/hooks/useIsMobile';
import { Spin } from 'antd';
import styled from 'styled-components';

const FaqIntroPage = () => {
  const isMobile = useIsMobile();

  if (isMobile === null) {
    return (
      <SpinnerWrapper>
        <Spin size="large" />
      </SpinnerWrapper>
    );
  }

  return isMobile ? <MobileFaq /> : <PcFaq />;
};

export default FaqIntroPage;

// ✅ 중앙 정렬용 스타일
const SpinnerWrapper = styled.div`
  display: flex;
  height: 100vh;
  align-items: center;
  justify-content: center;
`;
